import React from "react";
import { Link } from "react-router-dom";
export default function Notfound() {
  return (
    <>
      <div
        style={{
          position: "absolute",
          backgroundColor: "#000F9F",
          width: "100%",
          height: "100%",
          backgroundSize: "cover",
        }}
      >
        <div style={{ position: "absolute", top: "45%", left: "40%" }}>
          <div className="row">
            <span className="font-mont-b c-white fs-30">
              404 Page Not Found
            </span>
          </div>
          <div className="row">
            <Link to="/" style={{ marginLeft: "25%" }}>
              <span className="font-mont-b  fs-18">Go to homepage</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
